// Constants
import translation_DE from 'locales/translation_DE.json'
import translation_EN from 'locales/translation_EN.json'
import translation_FR from 'locales/translation_FR.json'
import translation_AR from 'locales/translation_AR.json'

export const languages = {
  en: 'en',
  de: 'de',
  fr: 'fr',
  ar: 'ar',
}

export const resources = {
  [languages.en]: {
    translation: translation_EN,
  },
  [languages.de]: {
    translation: translation_DE,
  },
  [languages.fr]: {
    translation: translation_FR,
  },
  [languages.ar]: {
    translation: translation_AR,
  },
}
